export const SW_INIT = "SW_INIT";
export const SW_UPDATE = "SW_UPDATE";

interface ServiceWorkerAction {
    type: string;
    payload?: any;
}

export type ServiceWorkerActionTypes = ServiceWorkerAction;
